import React from 'react';

import {svgIconWrapper} from '../svg-icon-wrapper';

import TimelineRegularAi from './timeline-regular-ai-icon.svg';

// @ts-expect-error
function SvgComponent(props) {
    const validProps = Object.assign({}, props);
    delete validProps.styles;

    return <TimelineRegularAi {...validProps} />;
}
SvgComponent.iconName = 'timelineRegularAi';

export const TimelineRegularAiIcon = svgIconWrapper(SvgComponent);
